import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js"

/**
 * Make a csv button to download a csv file with the form data
 *
 * @example
 * <form>
 *        <button type="button"
 *               data-url="/reservations"
 *               data-filename="reservations.csv"
 *               data-controller="csv-button" >
 *         <i class="bi bi-cloud-arrow-down-fill"></i>
 *         CSV
 *       </button>
 * </form>
 */

export default class CsvButtonController extends Controller {
  static values = {}

  initialize() {
    this.form = this.element.closest("form");

    this.element.addEventListener('click', (e) => {
      console.log("=> CSV Button clicked", this.form);
      this.doSubmit(this.form);
    });
  }

  doSubmit(form) {
    this.element.disabled = true;

    const params = new URLSearchParams(new FormData(form));
    const url = this.element.dataset.url || this.form.action;

    const urlWithParams = `${url}?${params.toString()}&format=csv`;

    get(urlWithParams, {responseKind: "blob"})
      .then(response => {
        console.debug("CSV Button RESPONSE", response);
        if (response.ok) {
          return response.text;
        }
      })
      .then((content) => {
        this.element.disabled = false;

        if (content) {
          this.downloadCsv(content);
        }
      });
  }

  downloadCsv(content) {
    const filename = this.element.dataset.filename || "export.csv";
    const blob = new Blob([content], {type: "application/text"});
    const a = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url)
  }
}
